import React from "react";
import { RefineLayoutHeaderProps } from "@pankod/refine-ui-types";
import { Layout, Typography, Avatar, Space } from "antd";
import { useMe } from "context/MeContext";
import { Dropdown } from "@pankod/refine-antd";
import empty from "assets/img/empty_ava.png";
import { css } from "@emotion/react";
import tw from "twin.macro";
import { useLogout } from "@pankod/refine-core";
import RouterProvider from "@pankod/refine-react-router-v6";
import homeIcon from "../../../../assets/img/home1.svg"

const { Link } = RouterProvider;
const { Text } = Typography;
export const Header: React.FC<RefineLayoutHeaderProps> = () => {
  const { me: user } = useMe();
  const { mutate: logout } = useLogout();
  const shouldRenderHeader = user && (user.username || user.icon);
  const profile = (
    <div
      className="flex flex-col bg-white px-4 rounded-md"
      css={css`
        span {
          ${tw`text-[#00899f] py-1 w-full`}
        }
      `}
    >
      <span>
        <Text ellipsis className="text-black">
          {user?.username}
        </Text>
      </span>
      <span className="border-t py-2">
        <Text
          strong
          className="shadow-none border-none cursor-pointer"
          onClick={() => {
            logout();
          }}
        >
          Sign out
        </Text>
      </span>
    </div>
  );
  return shouldRenderHeader ? (
    <Layout.Header
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        //padding: "0px 24px",
        //height: "100px",
        paddingTop:20,
        paddingBottom:20,
        marginBottom: 20,
        backgroundColor: "white",
        borderBottom: "1px solid #dddddd",
      }}
      css={css`
        .home-link {
          display: flex;
          align-items: center;
          color: #7a8f9c; /* base color */
          transition: color 0.3s ease;
        }

        .home-link:hover, .ml-8:hover {
          color: #333; 
          transition: 0.3s ease;
          cursor: pointer;
        }

        .home-icon {
          fill: currentColor;
          width: 38px;
          height: 38px;
          display: block;
        }
      `}
    >
      <h1 style={{fontSize:35,marginTop:20,width:"100%",display:"flex",justifyContent:"center"}}>Administration Platform</h1>
      <Link to="/" className="home-link">
        <svg className="home-icon" id="Layer_1" height="38" viewBox="0 0 512 512" width="38" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m256 0c141.385 0 256 114.615 256 256s-114.615 256-256 256-256-114.615-256-256 114.615-256 256-256zm.006 136.842-90.79 75.521v165.729h43.009v-88.322a12.656 12.656 0 0 1 12.65-12.65h70.262a12.656 12.656 0 0 1 12.65 12.65v88.322h43.013v-165.729l-90.789-75.521zm28.294 241.25v-81.472h-56.583v81.472zm-121.177 19.5h185.742a17.44 17.44 0 0 0 17.422-17.416v-151.593l29.727 24.736a9.753 9.753 0 1 0 12.477-14.993l-146.247-121.666a9.764 9.764 0 0 0 -12.477 0l-146.246 121.666a9.743 9.743 0 1 0 12.448 14.993l29.756-24.736v151.594a17.416 17.416 0 0 0 17.393 17.416z" fill-rule="evenodd"/></svg>
      </Link>
      <Dropdown className="ml-8" overlay={profile} placement="bottomRight">
        <Space>
          <Avatar size="large" src={user?.icon || empty} alt={user?.firstname + " " + user?.lastname} />
        </Space>
      </Dropdown>
    </Layout.Header>
  ) : null;
};
